<template>
  <div class="back-link">
    <router-link class="stretched-link" :to="to">
      <span class="back-link__icon"><Icon icon="arrow-left" /></span> {{ text }}
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    to: {
      type: [Object, String],
      required: true,
    },
    text: {
      type: String,
    },
  },
};
</script>

<style scoped>
.back-link {
  margin-bottom: 30px;
  font-weight: normal;
  max-width: max-content;
}

.icon-arrow-left {
  stroke: #ff0020;
}

.back-link a {
  position: relative;
  display: inline-flex;
  align-items: center;
  color: inherit;
  text-decoration: none;
}

.back-link__icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  margin-right: 15px;
  border: 1px solid #e5e5e5;
  border-radius: 50%;
  transition: border 0.1s;
}

body.-notouch .back-link:hover {
  color: #ff0020;
}

body.-notouch .back-link:active {
  color: #ff0020;
}

body.-notouch .back-link:hover .back-link__icon {
  border-color: #ff0020;
}

body.-notouch .back-link:active .back-link__icon {
  border-color: #ff0020;
}

body.-notouch .text-white .back-link:hover {
  color: inherit;
}

body.-notouch .text-white .back-link:active {
  color: inherit;
}

body.-notouch .text-white .back-link:hover .back-link__icon {
  border-color: currentColor;
}

body.-notouch .text-white .back-link:active .back-link__icon {
  border-color: currentColor;
}
@media (max-width: 575px) {
  .back-link__icon {
    width: 44px;
    height: 44px;
  }
}
</style>
